import axios from 'axios';
import { BEPI_API } from '../../../shared/config/bepiApiPaths';

// Backend resource path is @Path("web/workshop/..."), mounted under servlet /web/*
const BASE_URL = BEPI_API.workshop;

export const WorkshopApi = {
  // Obter detalhes do workshop (cliente + estimativa + orçamento)
  getWorkshopDetails: (id) => axios.get(`${BASE_URL}/details/${id}`),

  // Receber equipamento (atualizar status para 'equipamento em analise')
  receiveEquipment: (id) => axios.post(`${BASE_URL}/estimates/${id}/receive`),

  // Registrar apontamentos técnicos
  submitApontamentos: (id, data) => axios.post(`${BASE_URL}/estimates/${id}/apontamentos`, data),

  // Carregar orçamento
  loadBudget: (data) => {
    const formData = new URLSearchParams();
    formData.append('user_id', data.user_id || '');
    formData.append('empresa', data.empresa || '');
    formData.append('orcamento_id', data.orcamento_id || '');
    formData.append('estimativa_id', data.estimativa_id || '');

    return axios.post(`${BASE_URL}/budgets/load`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },

  // Cadastrar equipamento
  registerEquipment: (_data) => Promise.reject(
    // TODO: INEXISTENTE no backend: /web/workshop/equipment/register
    new Error('Endpoint de cadastro de equipamento indisponivel no backend atual.')
  ),
};
